/* eslint-disable @typescript-eslint/no-unused-vars */
import { serializeTokens } from 'utils/serializeTokens'
import { bscTokens, pulseTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens(pulseTokens)

export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 2, 3) should always be at the top of the file.
   */
  {
    pid: 0,
    v1pid: 0,
    lpSymbol: 'MINTX',
    lpAddresses: {
      97: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
      56: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
      369: '0x8909B8bC02257B8B5678c6bcc59A950839F14F21',
    },
    token: serializedTokens.cake,
    quoteToken: serializedTokens.wbnb,
  },
  // {
  //   pid: 1,
  //   v1pid: 251,
  //   lpSymbol: 'MINTX-PLS LP',
  //   lpAddresses: {
  //     97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     56: CAKE_BNB_LP_MAINNET,
  //     369: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //   },
  //   token: serializedTokens.cake,
  //   quoteToken: serializedTokens.wbnb,
  // },
  {
    pid: 1,
    v1pid: 252,
    lpSymbol: 'PLS-DAI LP',
    lpAddresses: {
      97: '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
      56: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
      369: '0x146E1f1e060e5b5016Db0D118D2C5a11A240ae32',
    },
    token: serializedTokens.dai,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 2,
    v1pid: 251,
    lpSymbol: 'MINT-PLS LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      56: CAKE_BNB_LP_MAINNET,
      369: '0x5f2d8624e6abea8f679a1095182f4bc84fe148e0',
    },
    token: serializedTokens.mint,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 3,
    v1pid: 251,
    lpSymbol: 'MINT-MINTX LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      56: CAKE_BNB_LP_MAINNET,
      369: '0x85c62694671df2914728c9234655c691b6528bfe',
    },
    token: serializedTokens.mint,
    quoteToken: serializedTokens.cake,
  },
]

export default farms
